var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "header" }, [
      _c("a", { staticClass: "logo", attrs: { href: "/" } }, [
        _c("img", { attrs: { src: "/public/lmk_text@2x.png" } }),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }


// WEBPACK FOOTER //
// src/components/common/Header.vue